import { FormField as CredentialsFormField, type Credentials } from "../Credentials";

export type ResetPasswordCredentials = Credentials;

export class FormField extends CredentialsFormField {
    public static Password = 'password';
    public static ConfirmPassword = 'confirmPassword';
    public static ResetPasswordToken = 'token';
};
